<template>
  <div class="content page--profile-deleted">
    <div class="container">
      <form method="POST"
            action="#"
            class="form form--restore">
        <header-logo :logo-url="globalLogoUrl" />
        <h1 v-word:layout.profileDeleted.header></h1>

        <h2 v-word:layout.profileDeleted.text>
        </h2>

      </form>
    </div>
  </div>
</template>

<script>
import * as mixins from '../mixins';
import wordings from '../utils/wordings';
import config from 'config';

export default {
  props: ['store'],
  mixins: [mixins.wordedPage, mixins.pageWithLogo],
};
</script>



// WEBPACK FOOTER //
// src/pages/ProfileDeleted.vue